export function isSsr() {
  return import.meta.env.SSR;
}
